import { render, staticRenderFns } from "./StudentCoinsView.vue?vue&type=template&id=4c0771b6&scoped=true&"
import script from "./StudentCoinsView.vue?vue&type=script&lang=js&"
export * from "./StudentCoinsView.vue?vue&type=script&lang=js&"
import style0 from "./StudentCoinsView.vue?vue&type=style&index=0&id=4c0771b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0771b6",
  null
  
)

export default component.exports